import React from 'react';
import { Link } from 'react-router-dom';
import styles from '@/assets/styles/Menu.module.less';
import { components } from '@/api/types';

type UserInfo = components['schemas']['User'];
interface MenuProps {
  isLoggedIn: boolean;
  userInfo: UserInfo | null;
}

const Menu: React.FC<MenuProps> = ({ isLoggedIn, userInfo }) => {
  return (
    <nav className={styles.menu}>
      <div className={styles.menuItems}>
        <ul>
          <li>
            <Link to="/">首页</Link>
          </li>
          <li>
            <Link to="/dictionary">在线词典</Link>
          </li>
          <li>
            <Link to="/applications/text-analyze">日文注音</Link>
          </li>
          <li>
            <a href="https://kanji.furiflow.com">汉字贴</a>
          </li>
          {/* <li>
            <Link to="/applications">应用</Link>
          </li> */}
          {/* <li>
            <Link to="/discover">发现</Link>
          </li>
          <li>
            <Link to="/community">社区</Link>
          </li> */}
          {isLoggedIn && userInfo && (
            <li>
              <Link to="/study">学习中心</Link>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Menu;
